module.exports = __webpack_public_path__ + "static/media/Porpentina Goldstein 2.2df576ed.jpg";